<template>
	<div class="task-list-container">
		<task-item v-model="task.text" v-for="(task, index) in tasks" v-bind:key="task.id"
		  v-bind:is-selected="task.isSelected" v-on:task-selected="onTaskSelected(index)"
		  v-on:task-delete="onTaskDelete(index)" />
	</div>
</template>

<script>

import TaskItem from './TaskItem';

function onTaskSelected(index) {
	const currentTask = this.tasks[index];
	currentTask.isSelected = !currentTask.isSelected;
}

function onTaskDelete(index) {
	this.tasks.splice(index, 1);
}

export default {
	components: {
		TaskItem,
	},
	name: 'tasks-list',
	props: {
		tasks: {
			type: Array,
			required: true,
		},
	},
	methods: {
		onTaskSelected,
		onTaskDelete,
	},
};
</script>

<style lang="scss" scoped>
.task-list-container {
	display: flex;
	flex-wrap: wrap;
	max-width: 649px;
}

.task-list-container>* {
	flex: 1 1 calc(50% - 22px);
	margin: 0 0 15px 22px;
	max-width: 289.5px;
}

.task-list-container>*:not(:nth-child(2n)) {
	margin-left: 0;
}
</style>





// WEBPACK FOOTER //
// TasksList.vue?52845358